import { chatSdk } from '@wix/chat-sdk';
import { INIT_CHAT_SDK } from '../actions';

const chatSdkMiddleware = store => next => action => {
  switch (action.type) {
    case INIT_CHAT_SDK: {
      chatSdk.init({
        chatServerUrl: '/',
        chatToken: action.coreChatToken,
        ...(action.isBusinessChat ? { preFetch: false } : {}),
        experiments: store.getState().experimentsRaw,
      });

      return next(action);
    }
    default:
      return next(action);
  }
};

export default chatSdkMiddleware;
